import { render, staticRenderFns } from "./TableEtcCheck.vue?vue&type=template&id=bcfa0fb2&scoped=true&"
import script from "./TableEtcCheck.vue?vue&type=script&lang=js&"
export * from "./TableEtcCheck.vue?vue&type=script&lang=js&"
import style0 from "./TableEtcCheck.vue?vue&type=style&index=0&id=bcfa0fb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfa0fb2",
  null
  
)

export default component.exports